import { SportType } from '../types';

export interface InjuryLog {
  id: string;
  bodyPart: string;
  severity: 'mild' | 'moderate' | 'severe';
  painLevel: number; // 1 to 10
  sport: SportType;
  loggedDate: string;
  notes: string;
  status: 'active' | 'recovering' | 'recovered';
  recoveryProgress: number; // 0 to 100
  completedStretchesCount: number;
}

export interface StretchStep {
  title: string;
  durationSec: number;
  instruction: string;
}

export interface RecoveryStretch {
  id: string;
  title: string;
  sport: SportType;
  bodyPart: string;
  durationMinutes: number;
  xpReward: number;
  difficulty: 'Beginner' | 'Intermediate' | 'Advanced';
  description: string;
  thumbnailUrl: string;
  benefits: string;
  steps: StretchStep[];
}

export const INITIAL_INJURY_LOGS: InjuryLog[] = [];

export const RECOVERY_STRETCHES: RecoveryStretch[] = [];
